var React = require('react');

function BypassedQueriesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.6726 3.99408C17.9981 4.31951 17.9981 4.84715 17.6726 5.17259L7.08337 15.7618L2.32745 11.0059C2.00201 10.6805 2.00201 10.1528 2.32745 9.82741C2.65289 9.50197 3.18053 9.50197 3.50596 9.82741L7.08337 13.4048L16.4941 3.99408C16.8196 3.66864 17.3472 3.66864 17.6726 3.99408Z","fill":"#fff"}));
}

BypassedQueriesIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = BypassedQueriesIcon;

BypassedQueriesIcon.default = BypassedQueriesIcon;
